import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'MagnificPopup';
import * as moment from 'moment';
import { wcagOptions } from "./wcag";

export class dealsContainer {
	private $scope = $('[data-homepage-deals]');
	private wcag = new wcagOptions();
	private $deskDealsContainer = this.$scope.find('[data-homepage-deals-desktop-items]');
	private $mobDealsContainer = this.$scope.find('[data-homepage-deals-mobile-items]');
	private $deskDealsItems = this.$scope.find('[data-homepage-deals-desktop-items] [data-homepage-deals-display-item]');
	private $mobDealsItems = this.$scope.find('[data-homepage-deals-mobile-items] [data-homepage-deals-display-item]');

	/**
	 * [dealsOnLoadInit description]
	 * init deals component on page load
	 * - populate desktop & mobile fields with on load get data
	 */
	dealsOnLoadInit(): void  {
		let _self = this;
		let $defCountry = _self.$scope.find('[data-default-country]');

		// show component if js enabled
		_self.$scope.find('.deals-container').addClass('shown');

		_self.getDealsData().then((data:any) => {
			if (data.length) {
				_self.dealsSelect(data, $defCountry.val());
				let formattedData:Array<any> = _self.getTopFiveDestinations(data, $defCountry.val());

				if (formattedData.length) {
					_self.$deskDealsContainer.removeClass('hidden');
					_self.$mobDealsContainer.removeClass('hidden');
					_self.dealsPopulateListItems(formattedData, _self.$deskDealsItems);
					_self.dealsPopulateListItems(formattedData, _self.$mobDealsItems);
					_self.dealsLightBox();
				} else {
				// hide deals display containers if no deals to show
				_self.$scope.addClass("hidden")
				//_self.$deskDealsContainer.addClass('hidden');
				//_self.$mobDealsContainer.addClass('hidden');
				}
			}
			else {
                // hide deals display containers if no deals to show
                _self.$scope.addClass("hidden");
            }
		});
	}

	/**
	 * $.get deals data from url
	 * @param  {string} url [get url]
	 * @return {any}        [data object]
	 */
	getDealsData(url?:string): any {
		let _self = this;
		let dataUrl:string = _self.$scope.attr('data-homepage-deals-get-url');

		if (url) {
			dataUrl = url; // replace url if provided as
		}

		let getDealsData = $.Deferred();

		$.get(dataUrl)
			.done((data:any) => {
				var jsonData = data;
				if (typeof data !== 'object') {
					jsonData = JSON.parse(data);
				}
				getDealsData.resolve(jsonData);
			}).fail((error:any) => {
				getDealsData.reject(error);
			});

		return getDealsData.promise();
	}

	/**
	 * [dealsSelect description]
	 * init homepage deals dropdown box
	 */
	dealsSelect(data:any, defaultCityValue:string): void {
		let _self = this;
		let $dealsHomepageSelect: any = _self.$scope.find('[data-homepage-deals-select]');
		let rawData:any = data;

		// populate deals option from dataset
		let $rawCitiesOptions:any = _self.getDealsOptions(rawData);
		let $citiesOptions:any = $rawCitiesOptions.map((el:any, i:number) => {
			return {text: el.name, value: el.url}
		});

		$dealsHomepageSelect.selectize({
			options: $citiesOptions,
			onInitialize: function() {
				_self.wcag.selectizeInputAria($dealsHomepageSelect[0].selectize);
				// set selectize to default value specified in hidden input
				$dealsHomepageSelect[0].selectize.setValue(defaultCityValue, true);
			},
			onChange: function(value: any) {
				let curOption:any = $dealsHomepageSelect[0].selectize.options[value];

				// clear all images on change before populating
				_self.$scope.find('[data-display-image]').attr({
					'srcset': ''
				});

				let formattedData:Array<any> = _self.getTopFiveDestinations(rawData, value);
				if (formattedData.length) {
					_self.$deskDealsContainer.removeClass('hidden');
					_self.$mobDealsContainer.removeClass('hidden');
					_self.dealsPopulateListItems(formattedData, _self.$deskDealsItems);
					_self.dealsPopulateListItems(formattedData, _self.$mobDealsItems);
					_self.dealsLightBox();
				} else {
					// hide deals display containers if no deals to show
					_self.$deskDealsContainer.addClass('hidden');
					_self.$mobDealsContainer.addClass('hidden');
				}
			},
			sortField: 'text'
		});
	}

	/**
	 * [getDealsOptions description]
	 * get unique cities from entire raw dataset
	 * @param  {object} data [raw data]
	 * @return {any}         [filtered array of cities]
	 */
	getDealsOptions(data:any):any {
		let rawData:any = $.makeArray(data);
		let $listCities:Array<any> = [];
		let $filteredListCities:any = [];

		rawData.map((el:any) => {
			return $listCities.push(el.fromCity);
		});

		$listCities.map((el:any, i:number) => {
			let elemExists:number = $filteredListCities.findIndex((el2:any) => {
				return el2.name === el.name;
			});

			if (elemExists < 0) {
				$filteredListCities.push(el);
			}
		});

		return $filteredListCities;
	}

	/**
	 * [getTopFiveDestinations description]
	 * filter data to get top 5 destinations in order of:
	 * - priority
	 * - price
	 *
	 * same sort fn as c017 but with an additional Array.slice() to return
	 * top 5 of results only.
	 * @param  {Array<any>} data [raw data]
	 * @param  {string} toCityUrl [current city value]
	 * @return {any}             [formatted data]
	 */
	getTopFiveDestinations(data:Array<any>, toCityUrl:string): Array<any> {
		let _self = this;

		const rawData:Array<any> = data;
		let filteredData:any = rawData.filter((el:any, i: number) => {
			return el.fromCity.url === toCityUrl;
		});

		let formattedData:Array<any> = [];

		filteredData.sort((a:any, b:any) => {
			// multi-dimensional sort
			// https://stackoverflow.com/questions/9175268/javascript-sort-function-sort-by-first-then-by-second
			if (a.priority > b.priority) {
				return 1;
			} else if (a.priority < b.priority) {
				return -1;
			}

			// else go to the 2nd item
			if (a.price < b.price) {
				return -1;
			} else if (a.price > b.price) {
				return 1
			} else { // nothing to split them
				return 0;
			}
		});

		formattedData = filteredData.slice(0,5);

		return formattedData;
	}

	/**
	 * [dealsPopulateDesktop description]
	 * populate $.get data to deals containers (desktop/mobile)
	 * - container determined by $scope params
	 * @param {Array<any>} data [json data]
	 * @param {any} scope [parent container]
	 */
	dealsPopulateListItems(data:Array<any>, $scope:any): void {
		// every static rendering will use promise. no need to worry about async issue
		let _self = this;

		$scope.each((i:number, el:any) => {
			const $el:any = $(el);

			$el.addClass('loading');
			$el.removeClass('hidden');

			// populate if data exists
			if (data[i]) {
				$el.find('[data-popup-link]').attr({
					'data-deals-destcity': data[i].toCity.name,
					'data-deals-destcitycode': data[i].toCity.url,
					'data-deals-destcountry': data[i].toCountry.countryName,
					'data-deals-to-iata': data[i].toCity.url,
					'data-deals-fromcity': data[i].fromCity.name,
					'data-deals-fromcitycode': data[i].fromCity.url,
					'data-deals-fromcountry': data[i].fromCountry.countryName,
					'data-deals-from-iata': data[i].fromCity.url,
					'data-deals-currency': data[i].currency,
					'data-deals-amount': data[i].price,
					'data-deals-cabin': data[i].travelClassLabel,
					'data-deals-cabin-hidden': data[i].travelClass,
					'data-deals-triptype': data[i].packageTypeLabel,
					'data-deals-trip': data[i].packagetype,
					'data-deals-travelstartperiod': data[i].travelStartDate,
					'data-deals-travelendperiod': data[i].travelEndDate,
					'data-deals-tnc': data[i].tnc
				});

				$el.find('[data-display-promo-percentage]').text(data[i].discount);

				if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
					// mobile (only show first discount tag if exists)
					if (i === 0 && data[i].discount.length) {
						$el.find('[data-display-promo]').show();
					} else {
						$el.find('[data-display-promo]').hide();
					}
				} else {
					// desktop (show discount tags for all)
					if (data[i].discount.length) {
						$el.find('[data-display-promo]').show();
					} else {
						$el.find('[data-display-promo]').hide();
					}
				}
				$el.find('[data-display-destcity]').text(data[i].toCity.name);
				$el.find('[data-display-trip]').text(data[i].packagetype);
				$el.find('[data-display-triptype]').text(data[i].packageTypeLabel);
				$el.find('[data-display-cabin]').text(data[i].travelClassLabel);
				$el.find('[data-display-currency]').text(data[i].currency);
				$el.find('[data-display-price]').text(data[i].price);

				$el.find('[data-display-startdate]').text(data[i].travelStartDateLabel);
				$el.find('[data-display-enddate]').text(data[i].travelEndDateLabel);

				$el.find('[data-display-image]').attr({
					'srcset': data[i].imgPath,
					'alt': data[i].toCity.name
				});

				// 500ms delay to cater for image buffering
				setTimeout(function(){
					$el.removeClass('loading');
				}, 500);
			} else {
				$el.addClass('hidden');
			}

		});
	}

	/**
	 * [dealsLightBox description]
	 * this method handles ALL deals lightbox components
	 * - c009
	 * - c017
	 * please check all components when making changes
	 */
	dealsLightBox(): void {
		let _self = this;
		let $openPopupLink:any = _self.$scope.find('.open-popup-link');

		$openPopupLink.off('click.light-box').on('click.light-box', function(){
			let $dealsPopup: any = _self.$scope.find('.deals-popup');
			let $dealsFromCountryName: any   = $(this).attr('data-deals-fromcountry');
			let $dealsToCityName: any        = $(this).attr('data-deals-destcity');
			let $dealsToCityCode: any        = $(this).attr('data-deals-destcitycode');
			let $dealsToCountryName: any     = $(this).attr('data-deals-destcountry');
			let $dealsfromCity: any          = $(this).attr('data-deals-fromcity');
			let $dealsfromCityCode: any      = $(this).attr('data-deals-fromcitycode');
			let $dealsfromCountry: any       = $(this).attr('data-deals-fromcountry');
			let $dealsCurrencyType: any      = $(this).attr('data-deals-currency');
			let $dealsTicketPrice: any       = $(this).attr('data-deals-amount');
			let $dealsCabinClass: any        = $(this).attr('data-deals-cabin');
			let $dealsCabinClassText: any    = $(this).attr('data-deals-cabin-hidden');
			let $dealsTripType: any          = $(this).attr('data-deals-triptype');
			let $dealsTravelStartPeriod: any = $(this).attr('data-deals-travelstartperiod');
			let $dealsTravelEndPeriod: any   = $(this).attr('data-deals-travelendperiod');
			let $dealsFromIATA: any          = $(this).attr('data-deals-from-iata');
			let $dealsToIATA: any            = $(this).attr('data-deals-to-iata');
			let $dealsTnC: any							 = $(this).attr('data-deals-tnc');

			let $dealsRetTitle: any 				 = $dealsPopup.find('.dep-return--title .ret-title');
			let $dealRetDate: any 					 = $dealsPopup.find('.calendar-container .returnDate');
			let $dealCalendar: any 					 = $dealsPopup.find('.calendar-container');

			let isUkCitySelectedForIbeSearch: boolean = false;
			let ukCities: any;
			let $isEnableCNN: any = $('#isEnableCNN');
			if (($isEnableCNN.val() != 'null') && ($isEnableCNN.val() != '0') && ($isEnableCNN.val() != '')) {
				ukCities = ($('[data-teenager-cities]').data('teenager-cities') != 'null' && $('[data-teenager-cities]').data('teenager-cities') != '' && $('[data-teenager-cities]').data('teenager-cities') != undefined) ? $('[data-teenager-cities]').data('teenager-cities').split(','): [];
			}
			else {
				ukCities = [];
			}			
			if (ukCities.includes($dealsfromCityCode) || ukCities.includes($dealsToCityCode) ) {
					$('#passenger-details--deals .teenager-cat').css('display', 'block');
					$('#passenger-details--deals .is-uk').css('display', 'block');
					$('#passenger-details--deals .isnt-uk').css('display', 'none');
					isUkCitySelectedForIbeSearch = true;
				} else {
					$('#passenger-details--deals .isnt-uk').css('display', 'block');
					$('#passenger-details--deals .teenager-cat').css('display', 'none');
					$('#passenger-details--deals .is-uk').css('display', 'none');
					isUkCitySelectedForIbeSearch = false;			
				}
				
			// toggle oneway trip
			if ($(this).attr('data-deals-trip') !== "Return") {
				$dealsRetTitle.hide();
				$dealRetDate.hide();
				$dealCalendar.addClass('oneWayTrip').removeClass('returnTrip');
			} else {
				$dealsRetTitle.show();
				$dealRetDate.show();
				$dealCalendar.addClass('returnTrip').removeClass('oneWayTrip');
			}

			$dealsPopup.find('.dep-return--title').find('.date-form--title').addClass('input-filled');
			$dealsPopup.find('.city-country--list.from .city-name').html($dealsfromCity);
			$dealsPopup.find('.city-country--list.from .country-name').html($dealsfromCountry);
			$dealsPopup.find('.city-country--list.from .city-name').attr("data-code", $dealsfromCityCode);
			$dealsPopup.find('.city-country--list.from .iata').html('('+$dealsFromIATA+')');
			$dealsPopup.find('.city-country--list.to .city-name').html($dealsToCityName);
			$dealsPopup.find('.city-country--list.to .country-name').html($dealsToCountryName);
			$dealsPopup.find('.city-country--list.to .city-name').attr("data-code", $dealsToCityCode);
			$dealsPopup.find('.city-country--list.to .iata').html('('+$dealsToIATA+')');
			$dealsPopup.find('.currency-price .currency-name').html($dealsCurrencyType);
			$dealsPopup.find('.currency-price .price-amount').html($dealsTicketPrice);
			$dealsPopup.find('.cabin-class--type').html($dealsCabinClass);
			$dealsPopup.find('#cabin-class-hidden').html($dealsCabinClassText);
			
			$dealsPopup.find('.trip-type').html($dealsTripType);
			$dealsPopup.find('.tc-content').html($dealsTnC);

			let $dealsNowDate:any      = new Date();
			let $dealsTodayDate:any    = new Date($dealsNowDate.getFullYear(), $dealsNowDate.getMonth(), $dealsNowDate.getDate(), 0, 0, 0, 0).toISOString();
			let $dealsDepartureDateMoment:any  = moment(new Date($dealsTravelStartPeriod).toISOString()).format('YYYYMMDDhhmm');
			let $dealsTodayDateMoment    :any  = moment($dealsTodayDate).format('YYYYMMDDhhmm');
			let $ibeTodayDateMoment      :any  = moment($dealsTodayDate).format('DD MMM YYYY');
			let $dealsTravelStartDate:any;

			if ($dealsDepartureDateMoment < $dealsTodayDateMoment){
				$dealsTravelStartDate =  $ibeTodayDateMoment;
			} else {
				$dealsTravelStartDate =  $dealsTravelStartPeriod;
			}

			$dealsPopup.find('.departureDate').val($dealsTravelStartDate);
			$dealsPopup.find('.departureDate').datepicker( 'option', 'minDate', new Date($dealsTravelStartDate));
			$dealsPopup.find('.returnDate').datepicker( 'option', 'minDate', new Date($dealsTravelStartDate));
			$dealsPopup.find('.returnDate').val($dealsTravelEndPeriod);
			$dealsPopup.find('.departureDate').datepicker( 'option', 'maxDate', new Date($dealsTravelEndPeriod));
			$dealsPopup.find('.returnDate').datepicker( 'option', 'maxDate', new Date($dealsTravelEndPeriod));
			$dealsPopup.find('.tc-content').html($dealsTnC);
		});

		$openPopupLink.magnificPopup({
			type:'inline',
			midClick: true,
			callbacks: {
				afterClose: function() {
					$('.deals-error--validation').hide();
					$('.infant-booking--error').hide();
					$('.ticket-adult--input').val('1');
					$('.ticket-child--input').val('0');
					$('.ticket-infant--input').val('0');					
					$('.ticket-mob-child--input').val('0');
					$('.ticket-mob-adult--input').val('1');
					$('.ticket-mob-infant--input').val('0');
					$('.total-nos').html('1');
					$('.total-nos-sidetrip').html('1');
					$('.group-booking').hide();
					$('.ticket-teenager--input').val('0');
					$('.ticket-mob-teenager--input').val('0');
					$(".ticket-nos-btn").removeAttr('disabled');
					$(".mobile-ticketnos--btn").removeAttr('disabled');			
				}
			}
			// Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
		});
	}
}

let scope:Element = document.querySelector('[data-homepage-deals]');
if (scope){
	try {
		let dealscontainer = new dealsContainer();
			$(document).ready(function(){
				dealscontainer.dealsOnLoadInit();
			});
	} catch(e) {console.error(e);}
}
